export default [
  {
    path: '/institution',
    name: 'Institution',
    component: resolve => require(['@/views/Institution'], resolve),
    meta: {
      keepAlive: true // 需要被缓存
    }
  },
  // 新增-编辑
  {
    path: '/institution/form',
    name: 'InstitutionForm',
    component: resolve => require(['@/views/Institution/Form'], resolve)
  }
]
